jQuery(document).ready(function(){
    jQuery(".collapse.in").removeClass("in");

    jQuery('.slider .owl-carousel').owlCarousel({
        loop: true,
        items: 1,
        autoHeight: true,
        nav: true,
        dots: true
    });
    
    var slides = ($(window).width() < 514) ? 1 : 1;
    jQuery('.header-slider .owl-carousel').owlCarousel({
        loop: true,
        items: slides,
        autoplay: true
    });
});

jQuery( document ).ready( function( $ ) {

    $.fn.setimageheight = function() {
        $( this ).each( function( i, obj ) {
            var imgWidth = $( obj ).width();
            $( obj ).css('height', imgWidth);
        });
    };

    $( '.patient-info .image img' ).setimageheight();

    $( window ).on( 'resize', function() {
        $( '.patient-info .image img' ).setimageheight();
    });
});